import Auth from '@js/plugins/auth';
import Feature from '@js/plugins/feature';
import Unleash from '@js/plugins/unleash';

export default {
    computed: {
        canManagePromotions() {
            return (
                Feature.hasFeature('promotion') &&
                Auth.hasAnyPermission([
                    'franchise_manage_marketing',
                    'franchise_manage_pwp',
                ])
            );
        },

        hasPwpPermission() {
            return Auth.hasAnyPermission([
                'franchise_manage_pwp',
                'franchise_view_pwp',
            ]);
        },

        hasMarketingPermission() {
            return Auth.hasAnyPermission([
                'franchise_manage_marketing',
                'franchise_view_marketing',
            ]);
        },

        hasOnlyPwpPermission() {
            return this.hasPwpPermission && !this.hasMarketingPermission;
        },

        // Dealer self-service PWP (spec 021): Manage PWP without Manage Marketing.
        isDealerMode() {
            return (
                Unleash.hasFeature('dealer_pwp_approval') &&
                Auth.hasAnyPermission(['franchise_manage_pwp']) &&
                // Manage Marketing or Review PWP is HQ / Mesra (spec FR-001a).
                !Auth.hasAnyPermission([
                    'franchise_manage_marketing',
                    'franchise_review_pwp',
                ])
            );
        },

        // Dealers may edit only dealer-created promotions covering stations they
        // are all assigned to; HQ promotions are view-only (spec 021, FR-005).
        canEditPromotion() {
            if (!this.canManagePromotions) {
                return false;
            }

            const promotion = this.$store.getters['promotion/promotion'];

            if (!this.isDealerMode || _.isNil(promotion.id)) {
                return true;
            }

            const mine = Auth.outlets().map(Number);
            const outlets = (promotion.outlets || []).map(Number);

            return (
                !!promotion.is_dealer_created &&
                outlets.length > 0 &&
                outlets.every(id => mine.indexOf(id) !== -1)
            );
        },

        canReviewPwp() {
            return (
                Unleash.hasFeature('dealer_pwp_approval') &&
                Auth.hasAnyPermission(['franchise_review_pwp'])
            );
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/promotion/mixin/promotion-permissions.js